import { useMemo } from "react";
import Interaction from "../../../models/interactions/Interaction";
import { IShowCustomQuiz } from "../../../models/interactions/ShowCustomQuiz";
import NodeToggle from "../components/NodeToggle";
import SequenceLocalizedVariableInputField from "../components/SequenceLocalizedVariableInputField";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";

export default function ShowCustomQuizNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const showCustomQuiz = props.interaction as IShowCustomQuiz;
  const { updateInteraction } = useUpdateSequenceInteraction();

  const titleInput = useMemo(
    () => (
      <SequenceLocalizedVariableInputField
        label="Title"
        placeholder="Title"
        localizationKey={showCustomQuiz.title}
      />
    ),
    [showCustomQuiz.title],
  );

  const showUIStarsToggle = useMemo(
    () => (
      <NodeToggle
        label="Show UI Stars"
        value={showCustomQuiz.showUIStars}
        onChange={(showUIStars) =>
          updateInteraction(props.nodeId, {
            ...showCustomQuiz,
            showUIStars,
          } as IShowCustomQuiz)
        }
      />
    ),
    [showCustomQuiz.showUIStars, updateInteraction, props.nodeId],
  );

  return (
    <div className="w-full h-full flex flex-col gap-[12px]">
      {titleInput}
      {showUIStarsToggle}
    </div>
  );
}
